import controller from './payment-orders.controller';
import template from './payment-orders.view.html';

let PaymentOrdersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PaymentOrdersComponent;



// WEBPACK FOOTER //
// ./www/components/payments-advances/payment-orders/payment-orders.component.js